var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.4 6.1H2.2L6.3 10c.2.2.3.6 0 .8-.2.2-.6.2-.9 0L.2 6c-.2-.2-.2-.6 0-.8l5.2-5c.2-.2.6-.2.9 0 .2.2.2.6 0 .8L2.1 4.9h11.3c.3 0 .6.3.6.6s-.2.6-.6.6"
  })));
};
export default SvgArrowLeft;